import { generateRecentTimestamp } from "utils/timestamp";
const routes = {
  activeRoutes: {
    totalCount: "6",
    routes: [
     {
        route: "Route#1",
        busId: "Bus#1",
        noOfBuses: "02",
        fuelConsumed: "20 Gal",
        distanceCovered: "20 Miles",
        stops: "02/05",
        driver: "Tim John",
        nextMaintanance: "09-25-2025",
        totalPassengers: "25896",
        safetyScore: "85",
        totalTrips: "456",
        licensePlateNo: "PB1672",
        timeStamp: generateRecentTimestamp(),
        trip: [
          {
            tripNo: "1",
            speed: "10 mph",
            fuelConsumed: "20 Gal",
            distanceCovered: "20 Miles",
            driver: "Ahmed Al Mansoori",
            tripStatus: "In Progress",
            distance: "150 Miles",
            routeDetails: {
              route: "Route#1",
              occupancy: "20/40",
              videoUrl: "http://busVideo",
              routeStops: {
                totalStops: "5",
                stopsCovered: "3",
                stoppages: [
                  {
                    name: "Source",
                    observation: "15 Min Delay",
                    area: "Al Maryah Island, Abu Dhabi",
                    coOrdinates: { lat: "24.5015", lng: "54.3850" },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Current Location",
                    observation: "Over Speeding",
                    area: "Al Reem Island, Abu Dhabi",
                    coOrdinates: { lat: "24.4833", lng: "54.3833" },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Stop 1",
                    observation: "Next Stop",
                    area: "Corniche Road, Abu Dhabi",
                    coOrdinates: { lat: "24.4667", lng: "54.3333" },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Stop 2",
                    observation: "",
                    area: "Al Bateen, Abu Dhabi",
                    coOrdinates: { lat: "24.4500", lng: "54.3500" },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Stop 3",
                    observation: "",
                    area: "Al Karamah, Abu Dhabi",
                    coOrdinates: { lat: "24.4500", lng: "54.3667" },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Destination",
                    observation: "",
                    area: "Yas Island, Abu Dhabi",
                    coOrdinates: { lat: "24.4885", lng: "54.6050" },
                    timeStamp: generateRecentTimestamp(),
                  },
                ],
              },
            },
          },
          {
            tripNo: "2",
            speed: "10 mph",
            fuelConsumed: "20 Gal",
            distanceCovered: "20 Miles",
            driver: "Ahmed Al Mansoori",
            tripStatus: "Completed",
            distance: "150 Miles",
            routeDetails: {
              route: "Route#2",
              occupancy: "20/40",
              videoUrl: "http://busVideo",
              routeStops: {
                totalStops: "5",
                stopsCovered: "3",
                stoppages: [
                  {
                    name: "Source",
                    observation: "15 Min Delay",
                    area: "Khalifa City, Abu Dhabi",
                    coOrdinates: { lat: "24.4333", lng: "54.4333" },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Current Location",
                    observation: "Over Speeding",
                    area: "Al Bahia, Abu Dhabi",
                    coOrdinates: { lat: "24.4167", lng: "54.4500" },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Stop 1",
                    observation: "Next Stop",
                    area: "Al Raha Beach, Abu Dhabi",
                    coOrdinates: { lat: "24.4500", lng: "54.4667" },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Stop 2",
                    observation: "",
                    area: "Al Raha Gardens, Abu Dhabi",
                    coOrdinates: { lat: "24.4500", lng: "54.4833" },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Stop 3",
                    observation: "",
                    area: "Khalifa Park, Abu Dhabi",
                    coOrdinates: { lat: "24.4167", lng: "54.5167" },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Destination",
                    observation: "",
                    area: "Al Raha Mall, Abu Dhabi",
                    coOrdinates: { lat: "24.4333", lng: "54.5000" },
                    timeStamp: generateRecentTimestamp(),
                  },
                ],
              },
            },
          },
        ],
        pastViolations: [
          {
            violationType: "overspeeding",
            busNo: "1",
            route: "Route#1",
            timeStamp: generateRecentTimestamp(),
          },
          {
            violationType: "overspeeding",
            busNo: "1",
            route: "Route#1",
            timeStamp: generateRecentTimestamp(),
          },
          {
            violationType: "overspeeding",
            busNo: "1",
            route: "Route#1",
            timeStamp: generateRecentTimestamp(),
          },
          {
            violationType: "overspeeding",
            busNo: "1",
            route: "Route#2",
            timeStamp: generateRecentTimestamp(),
          },
          {
            violationType: "overspeeding",
            busNo: "1",
            route: "Route#1",
            timeStamp: generateRecentTimestamp(),
          },
        ],
        source: {
          area: "Corniche Beach, Abu Dhabi",
          coOrdinates: {
            lat: 24.3236,
            lng: 54.5647
          }
        },
        destination: {
          area: "Sheikh Zayed Grand Mosque, Abu Dhabi",
          coOrdinates: {
            lat: 24.412700,
            lng: 54.474900
          }
        },
        currentLocation: {
          area: "Marina Mall, Abu Dhabi",
          coOrdinates: {
            lat: 24.466600,
            lng: 54.321100
          }
        },
        nextStop: {
          area: "Emirates Palace, Abu Dhabi",
          coOrdinates: {
            lat: 24.457900,
            lng: 54.322700
          }
        },
      },
      {
        route: "Route#2",
        busId: "Bus#2",
        noOfBuses: "02",
        fuelConsumed: "20 Gal",
        distanceCovered: "20 Miles",
        stops: "02/05",
        driver: "Noor Ali",
        nextMaintanance: "09-25-2025",
        totalPassengers: "25896",
        safetyScore: "85",
        totalTrips: "456",
        licensePlateNo: "PB1672",
        timeStamp: generateRecentTimestamp(),
        trip: [
          {
            tripNo: "1",
            speed: "10 mph",
            fuelConsumed: "20 Gal",
            distanceCovered: "20 Miles",
            driver: "Ahmed Al Mansoori",
            tripStatus: "In Progress",
            distance: "150 Miles",
            routeDetails: {
              route: "Route#1",
              occupancy: "20/40",
              videoUrl: "http://busVideo",
              routeStops: {
                totalStops: "5",
                stopsCovered: "3",
                stoppages: [
                  {
                    name: "Source",
                    observation: "15 Min Delay",
                    area: "Al Maryah Island, Abu Dhabi",
                    coOrdinates: { lat: 24.5015, lng: 54.3850 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Current Location",
                    observation: "Over Speeding",
                    area: "Al Reem Island, Abu Dhabi",
                    coOrdinates: { lat: 24.4833, lng: 54.3833 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Stop 1",
                    observation: "Next Stop",
                    area: "Corniche Road, Abu Dhabi",
                    coOrdinates: { lat: 24.4667, lng: 54.3333 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Stop 2",
                    observation: "",
                    area: "Al Bateen, Abu Dhabi",
                    coOrdinates: { lat: 24.4500, lng: 54.3500 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Stop 3",
                    observation: "",
                    area: "Al Karamah, Abu Dhabi",
                    coOrdinates: { lat: 24.4500, lng: 54.3667 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Destination",
                    observation: "",
                    area: "Yas Island, Abu Dhabi",
                    coOrdinates: { lat: 24.4885, lng: 54.6050 },
                    timeStamp: generateRecentTimestamp(),
                  },
                ],
              },
            },
          },
          {
            tripNo: "2",
            speed: "10 mph",
            fuelConsumed: "20 Gal",
            distanceCovered: "20 Miles",
            driver: "Ahmed Al Mansoori",
            tripStatus: "Completed",
            distance: "150 Miles",
            routeDetails: {
              route: "Route#2",
              occupancy: "20/40",
              videoUrl: "http://busVideo",
              routeStops: {
                totalStops: "5",
                stopsCovered: "3",
                stoppages: [
                  {
                    name: "Source",
                    observation: "15 Min Delay",
                    area: "Khalifa City, Abu Dhabi",
                    coOrdinates: { lat: 24.4333, lng: 54.4333 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Current Location",
                    observation: "Over Speeding",
                    area: "Al Bahia, Abu Dhabi",
                    coOrdinates: { lat: 24.4167, lng: 54.4500 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Stop 1",
                    observation: "Next Stop",
                    area: "Al Raha Beach, Abu Dhabi",
                    coOrdinates: { lat: 24.4500, lng: 54.4667 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Stop 2",
                    observation: "",
                    area: "Al Raha Gardens, Abu Dhabi",
                    coOrdinates: { lat: 24.4500, lng: 54.4833 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Stop 3",
                    observation: "",
                    area: "Khalifa Park, Abu Dhabi",
                    coOrdinates: { lat: 24.4167, lng: 54.5167 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Destination",
                    observation: "",
                    area: "Al Raha Mall, Abu Dhabi",
                    coOrdinates: { lat: 24.4333, lng: 54.5000 },
                    timeStamp: generateRecentTimestamp(),
                  },
                ],
              },
            },
          },
        ],
        pastViolations: [
          {
            violationType: "overspeeding",
            busNo: "1",
            route: "Route#1",
            timeStamp: generateRecentTimestamp(),
          },
          {
            violationType: "overspeeding",
            busNo: "1",
            route: "Route#1",
            timeStamp: generateRecentTimestamp(),
          },
          {
            violationType: "overspeeding",
            busNo: "1",
            route: "Route#1",
            timeStamp: generateRecentTimestamp(),
          },
          {
            violationType: "overspeeding",
            busNo: "1",
            route: "Route#2",
            timeStamp: generateRecentTimestamp(),
          },
          {
            violationType: "overspeeding",
            busNo: "1",
            route: "Route#1",
            timeStamp: generateRecentTimestamp(),
          },
        ],
        source: {
          area: "Al Maryah Island, Abu Dhabi",
          coOrdinates: {
            lat: 24.5015,
            lng: 54.3850,
          },
        },
        destination: {
          area: "Yas Island, Abu Dhabi",
          coOrdinates: {
            lat: 24.4885,
            lng: 54.6050,
          },
        },
        currentLocation: {
          area: "Al Reem Island, Abu Dhabi",
          coOrdinates: {
            lat: 24.4833,
            lng: 54.3833,
          },
        },
        nextStop: {
          area: "Corniche Road, Abu Dhabi",
          coOrdinates: {
            lat: 24.4667,
            lng: 54.3333,
          },
        },
      },
      {
        route: "Route#3",
        busId: "Bus#5",
        noOfBuses: "03",
        fuelConsumed: "25 Gal",
        distanceCovered: "30 Miles",
        stops: "03/07",
        driver: "Salem Al Falasi",
        nextMaintanance: "11-15-2025",
        totalPassengers: "30240",
        safetyScore: "92",
        totalTrips: "512",
        licensePlateNo: "AD4520",
        timeStamp: generateRecentTimestamp(),
        trip: [
          {
            tripNo: "1",
            speed: "15 mph",
            fuelConsumed: "15 Gal",
            distanceCovered: "25 Miles",
            driver: "Salem Al Falasi",
            tripStatus: "In Progress",
            distance: "120 Miles",
            routeDetails: {
              route: "Route#5",
              occupancy: "25/40",
              videoUrl: "http://busVideoRoute5",
              routeStops: {
                totalStops: "7",
                stopsCovered: "4",
                stoppages: [
                  {
                    name: "Source",
                    observation: "No Delay",
                    area: "Al Rawdah, Abu Dhabi",
                    coOrdinates: { lat: 24.4560, lng: 54.3940 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Current Location",
                    observation: "Smooth Ride",
                    area: "Al Mushrif, Abu Dhabi",
                    coOrdinates: { lat: 24.4375, lng: 54.3827 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Stop 1",
                    observation: "Next Stop",
                    area: "Al Wahda Mall, Abu Dhabi",
                    coOrdinates: { lat: 24.4803, lng: 54.3506 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Stop 2",
                    observation: "",
                    area: "Al Khalidiyah, Abu Dhabi",
                    coOrdinates: { lat: 24.4788, lng: 54.3529 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Stop 3",
                    observation: "",
                    area: "Al Marina, Abu Dhabi",
                    coOrdinates: { lat: 24.4792, lng: 54.3345 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Stop 4",
                    observation: "",
                    area: "Al Khalifa City, Abu Dhabi",
                    coOrdinates: { lat: 24.4325, lng: 54.4120 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Destination",
                    observation: "",
                    area: "Al Raha Mall, Abu Dhabi",
                    coOrdinates: { lat: 24.4333, lng: 54.5000 },
                    timeStamp: generateRecentTimestamp(),
                  },
                ],
              },
            },
          },
          {
            tripNo: "2",
            speed: "18 mph",
            fuelConsumed: "18 Gal",
            distanceCovered: "28 Miles",
            driver: "Salem Al Falasi",
            tripStatus: "Completed",
            distance: "130 Miles",
            routeDetails: {
              route: "Route#6",
              occupancy: "30/40",
              videoUrl: "http://busVideoRoute6",
              routeStops: {
                totalStops: "6",
                stopsCovered: "6",
                stoppages: [
                  {
                    name: "Source",
                    observation: "On Schedule",
                    area: "Al Maqta, Abu Dhabi",
                    coOrdinates: { lat: 24.3876, lng: 54.5041 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Current Location",
                    observation: "Normal Traffic",
                    area: "Al Mushrif, Abu Dhabi",
                    coOrdinates: { lat: 24.4375, lng: 54.3827 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Stop 1",
                    observation: "Next Stop",
                    area: "Al Nahyan, Abu Dhabi",
                    coOrdinates: { lat: 24.4665, lng: 54.3655 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Stop 2",
                    observation: "",
                    area: "Al Bateen, Abu Dhabi",
                    coOrdinates: { lat: 24.4500, lng: 54.3500 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Stop 3",
                    observation: "",
                    area: "Al Khalidiyah, Abu Dhabi",
                    coOrdinates: { lat: 24.4788, lng: 54.3529 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Destination",
                    observation: "",
                    area: "Marina Mall, Abu Dhabi",
                    coOrdinates: { lat: 24.4672, lng: 54.3212 },
                    timeStamp: generateRecentTimestamp(),
                  },
                ],
              },
            },
          },
        ],
        pastViolations: [
          {
            violationType: "overspeeding",
            busNo: "5",
            route: "Route#5",
            timeStamp: generateRecentTimestamp(),
          },
          {
            violationType: "harsh braking",
            busNo: "5",
            route: "Route#6",
            timeStamp: generateRecentTimestamp(),
          },
          {
            violationType: "route deviation",
            busNo: "5",
            route: "Route#5",
            timeStamp: generateRecentTimestamp(),
          },
        ],
        source: {
          area: "Al Rawdah, Abu Dhabi",
          coOrdinates: { lat: 24.4560, lng: 54.3940 },
        },
        destination: {
          area: "Al Raha Mall, Abu Dhabi",
          coOrdinates: { lat: 24.4539, lng: 54.3776 },
        },
        currentLocation: {
          area: "Al Mushrif, Abu Dhabi",
          coOrdinates: { lat: 24.4375, lng: 54.3827 },
        },
        nextStop: {
          area: "Al Wahda Mall, Abu Dhabi",
          coOrdinates: { lat: 24.4803, lng: 54.3506 },
        },
      },
      {
        route: "Route#4",
        busId: "Bus#12",
        noOfBuses: "04",
        fuelConsumed: "28 Gal",
        distanceCovered: "35 Miles",
        stops: "03/06",
        driver: "Khalid Al Hammadi",
        nextMaintanance: "12-05-2025",
        totalPassengers: "31025",
        safetyScore: "88",
        totalTrips: "489",
        licensePlateNo: "AD6724",
        timeStamp: generateRecentTimestamp(),
        trip: [
          {
            tripNo: "1",
            speed: "14 mph",
            fuelConsumed: "14 Gal",
            distanceCovered: "25 Miles",
            driver: "Khalid Al Hammadi",
            tripStatus: "In Progress",
            distance: "110 Miles",
            routeDetails: {
              route: "Route#3",
              occupancy: "23/40",
              videoUrl: "http://busVideoRoute3",
              routeStops: {
                totalStops: "6",
                stopsCovered: "3",
                stoppages: [
                  {
                    name: "Source",
                    observation: "No Delay",
                    area: "Al Mushrif, Abu Dhabi",
                    coOrdinates: { lat: 24.4378, lng: 54.3850 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Current Location",
                    observation: "Smooth Ride",
                    area: "Al Nahyan, Abu Dhabi",
                    coOrdinates: { lat: 24.4667, lng: 54.3667 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Stop 1",
                    observation: "Next Stop",
                    area: "Al Khalidiyah, Abu Dhabi",
                    coOrdinates: { lat: 24.4788, lng: 54.3529 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Stop 2",
                    observation: "",
                    area: "Al Bateen, Abu Dhabi",
                    coOrdinates: { lat: 24.4500, lng: 54.3500 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Stop 3",
                    observation: "",
                    area: "Corniche Road, Abu Dhabi",
                    coOrdinates: { lat: 24.4667, lng: 54.3333 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Destination",
                    observation: "",
                    area: "Marina Mall, Abu Dhabi",
                    coOrdinates: { lat: 24.4672, lng: 54.3212 },
                    timeStamp: generateRecentTimestamp(),
                  },
                ],
              },
            },
          },
          {
            tripNo: "2",
            speed: "16 mph",
            fuelConsumed: "16 Gal",
            distanceCovered: "28 Miles",
            driver: "Khalid Al Hammadi",
            tripStatus: "Completed",
            distance: "130 Miles",
            routeDetails: {
              route: "Route#4",
              occupancy: "30/40",
              videoUrl: "http://busVideoRoute4",
              routeStops: {
                totalStops: "5",
                stopsCovered: "5",
                stoppages: [
                  {
                    name: "Source",
                    observation: "On Time",
                    area: "Al Maqta, Abu Dhabi",
                    coOrdinates: { lat: 24.3876, lng: 54.5041 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Current Location",
                    observation: "Busy Traffic",
                    area: "Al Mushrif, Abu Dhabi",
                    coOrdinates: { lat: 24.4378, lng: 54.3850 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Stop 1",
                    observation: "Next Stop",
                    area: "Al Danah, Abu Dhabi",
                    coOrdinates: { lat: 24.4961, lng: 54.3709 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Stop 2",
                    observation: "",
                    area: "Zayed Sports City, Abu Dhabi",
                    coOrdinates: { lat: 24.4188, lng: 54.4857 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Destination",
                    observation: "",
                    area: "Yas Island, Abu Dhabi",
                    coOrdinates: { lat: 24.4885, lng: 54.6050 },
                    timeStamp: generateRecentTimestamp(),
                  },
                ],
              },
            },
          },
          {
            tripNo: "3",
            speed: "15 mph",
            fuelConsumed: "15 Gal",
            distanceCovered: "26 Miles",
            driver: "Khalid Al Hammadi",
            tripStatus: "In Progress",
            distance: "115 Miles",
            routeDetails: {
              route: "Route#5",
              occupancy: "27/40",
              videoUrl: "http://busVideoRoute5",
              routeStops: {
                totalStops: "6",
                stopsCovered: "4",
                stoppages: [
                  {
                    name: "Source",
                    observation: "Starting",
                    area: "Al Reem Island, Abu Dhabi",
                    coOrdinates: { lat: 24.4934, lng: 54.4103 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Current Location",
                    observation: "Boarding Passengers",
                    area: "Al Maryah Island, Abu Dhabi",
                    coOrdinates: { lat: 24.5015, lng: 54.3850 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Stop 1",
                    observation: "Next Stop",
                    area: "Al Bahia, Abu Dhabi",
                    coOrdinates: { lat: 24.4167, lng: 54.4500 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Stop 2",
                    observation: "",
                    area: "Al Rahah Gardens, Abu Dhabi",
                    coOrdinates: { lat: 24.4500, lng: 54.4833 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Stop 3",
                    observation: "",
                    area: "Khalifa Park, Abu Dhabi",
                    coOrdinates: { lat: 24.4167, lng: 54.5167 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Destination",
                    observation: "",
                    area: "Al Raha Mall, Abu Dhabi",
                    coOrdinates: { lat: 24.4333, lng: 54.5000 },
                    timeStamp: generateRecentTimestamp(),
                  },
                ],
              },
            },
          },
        ],
        pastViolations: [
          {
            violationType: "overspeeding",
            busNo: "12",
            route: "Route#3",
            timeStamp: generateRecentTimestamp(),
          },
          {
            violationType: "harsh braking",
            busNo: "12",
            route: "Route#4",
            timeStamp: generateRecentTimestamp(),
          },
          {
            violationType: "signal jumping",
            busNo: "12",
            route: "Route#5",
            timeStamp: generateRecentTimestamp(),
          },
        ],
        source: {
          area: "Mazyad Mall, Abu Dhabi",
          coOrdinates: {lat:24.28729,lng: 54.64128,},
        },
        destination: {
          area: "Al Faya Restauran",
          coOrdinates: { lat: 24.3564, lng: 54.9103  },
        },
        currentLocation: {
          area: "Al Nahyan, Abu Dhabi",
          coOrdinates: {lat:24.28729,lng: 54.64128 },
        },
        nextStop: {
          area: "Al Khalidiyah, Abu Dhabi",
          coOrdinates: { lat: 24.4788, lng: 54.3529 },
        },
      },
      {
        route: "Route#5",
        busId: "Bus#22",
        noOfBuses: "03",
        fuelConsumed: "30 Gal",
        distanceCovered: "40 Miles",
        stops: "04/07",
        driver: "Aisha Al Mansoori",
        nextMaintanance: "12-10-2025",
        totalPassengers: "27500",
        safetyScore: "90",
        totalTrips: "520",
        licensePlateNo: "AD7821",
        timeStamp: generateRecentTimestamp(),
        trip: [
          {
            tripNo: "1",
            speed: "20 mph",
            fuelConsumed: "15 Gal",
            distanceCovered: "25 Miles",
            driver: "Aisha Al Mansoori",
            tripStatus: "In Progress",
            distance: "110 Miles",
            routeDetails: {
              route: "Route#9",
              occupancy: "22/40",
              videoUrl: "http://busVideoRoute9",
              routeStops: {
                totalStops: "7",
                stopsCovered: "4",
                stoppages: [
                  {
                    name: "Source",
                    observation: "On Time",
                    area: "Al Mushrif, Abu Dhabi",
                    coOrdinates: { lat: 24.4378, lng: 54.3850 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Current Location",
                    observation: "Smooth Ride",
                    area: "Al Nahyan, Abu Dhabi",
                    coOrdinates: { lat: 24.4667, lng: 54.3667 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Stop 1",
                    observation: "Next Stop",
                    area: "Al Khalidiyah, Abu Dhabi",
                    coOrdinates: { lat: 24.4788, lng: 54.3529 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Stop 2",
                    observation: "",
                    area: "Al Bateen, Abu Dhabi",
                    coOrdinates: { lat: 24.4500, lng: 54.3500 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Stop 3",
                    observation: "",
                    area: "Corniche Road, Abu Dhabi",
                    coOrdinates: { lat: 24.4667, lng: 54.3333 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Destination",
                    observation: "",
                    area: "Marina Mall, Abu Dhabi",
                    coOrdinates: { lat: 24.4672, lng: 54.3212 },
                    timeStamp: generateRecentTimestamp(),
                  },
                ],
              },
            },
          },
          {
            tripNo: "2",
            speed: "18 mph",
            fuelConsumed: "13 Gal",
            distanceCovered: "30 Miles",
            driver: "Aisha Al Mansoori",
            tripStatus: "Completed",
            distance: "125 Miles",
            routeDetails: {
              route: "Route#14",
              occupancy: "28/40",
              videoUrl: "http://busVideoRoute14",
              routeStops: {
                totalStops: "6",
                stopsCovered: "6",
                stoppages: [
                  {
                    name: "Source",
                    observation: "Early Start",
                    area: "Al Maqta, Abu Dhabi",
                    coOrdinates: { lat: 24.3876, lng: 54.5041 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Current Location",
                    observation: "Traffic Jam",
                    area: "Al Mushrif, Abu Dhabi",
                    coOrdinates: { lat: 24.4378, lng: 54.3850 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Stop 1",
                    observation: "Next Stop",
                    area: "Al Danah, Abu Dhabi",
                    coOrdinates: { lat: 24.4961, lng: 54.3709 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Stop 2",
                    observation: "",
                    area: "Zayed Sports City, Abu Dhabi",
                    coOrdinates: { lat: 24.4188, lng: 54.4857 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Destination",
                    observation: "",
                    area: "Yas Island, Abu Dhabi",
                    coOrdinates: { lat: 24.4885, lng: 54.6050 },
                    timeStamp: generateRecentTimestamp(),
                  },
                ],
              },
            },
          },
          {
            tripNo: "3",
            speed: "16 mph",
            fuelConsumed: "14 Gal",
            distanceCovered: "28 Miles",
            driver: "Aisha Al Mansoori",
            tripStatus: "In Progress",
            distance: "118 Miles",
            routeDetails: {
              route: "Route#23",
              occupancy: "24/40",
              videoUrl: "http://busVideoRoute23",
              routeStops: {
                totalStops: "5",
                stopsCovered: "3",
                stoppages: [
                  {
                    name: "Source",
                    observation: "Starting Trip",
                    area: "Al Reem Island, Abu Dhabi",
                    coOrdinates: { lat: 24.4934, lng: 54.4103 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Current Location",
                    observation: "Passenger Boarding",
                    area: "Al Maryah Island, Abu Dhabi",
                    coOrdinates: { lat: 24.5015, lng: 54.3850 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Stop 1",
                    observation: "Next Stop",
                    area: "Al Bahia, Abu Dhabi",
                    coOrdinates: { lat: 24.4167, lng: 54.4500 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Stop 2",
                    observation: "",
                    area: "Al Raha Gardens, Abu Dhabi",
                    coOrdinates: { lat: 24.4500, lng: 54.4833 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Destination",
                    observation: "",
                    area: "Khalifa Park, Abu Dhabi",
                    coOrdinates: { lat: 24.4167, lng: 54.5167 },
                    timeStamp: generateRecentTimestamp(),
                  },
                ],
              },
            },
          },
        ],
        pastViolations: [
          {
            violationType: "overspeeding",
            busNo: "22",
            route: "Route#9",
            timeStamp: generateRecentTimestamp(),
          },
          {
            violationType: "harsh braking",
            busNo: "22",
            route: "Route#14",
            timeStamp: generateRecentTimestamp(),
          },
          {
            violationType: "traffic signal violation",
            busNo: "22",
            route: "Route#23",
            timeStamp: generateRecentTimestamp(),
          },
        ],
        source: {
          area: "AL riyadh Hotel APartments, Abu Dhabi",
          coOrdinates: { lat: 24.366620, lng: 54.738840  },
        },
        destination: {
          area: "Al rehba coffe shope, Abu Dhabi",
          coOrdinates: { lat: 24.625662, lng: 54.713325 },
        },
        currentLocation: {
          area: "Al Nahyan, Abu Dhabi",
          coOrdinates: {lat: 24.366620, lng: 54.738840  },
        },
        nextStop: {
          area: "Al Khalidiyah, Abu Dhabi",
          coOrdinates: { lat: 24.4788, lng: 54.3529 },
        },
      },
      {
        route: "Route#6",
        busId: "Bus#33",
        noOfBuses: "03",
        fuelConsumed: "32 Gal",
        distanceCovered: "38 Miles",
        stops: "04/06",
        driver: "Yousef Al Mazrouei",
        nextMaintanance: "12-20-2025",
        totalPassengers: "28950",
        safetyScore: "87",
        totalTrips: "498",
        licensePlateNo: "AD8023",
        timeStamp: generateRecentTimestamp(),
        trip: [
          {
            tripNo: "1",
            speed: "17 mph",
            fuelConsumed: "16 Gal",
            distanceCovered: "26 Miles",
            driver: "Yousef Al Mazrouei",
            tripStatus: "In Progress",
            distance: "115 Miles",
            routeDetails: {
              route: "Route#12",
              occupancy: "26/40",
              videoUrl: "http://busVideoRoute12",
              routeStops: {
                totalStops: "6",
                stopsCovered: "4",
                stoppages: [
                  {
                    name: "Source",
                    observation: "On Time",
                    area: "Al Nahyan, Abu Dhabi",
                    coOrdinates: { lat: 24.4667, lng: 54.3667 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Current Location",
                    observation: "Smooth ride",
                    area: "Al Mushrif, Abu Dhabi",
                    coOrdinates: { lat: 24.4378, lng: 54.3850 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Stop 1",
                    observation: "Next Stop",
                    area: "Khalifa Park, Abu Dhabi",
                    coOrdinates: { lat: 24.4181, lng: 54.4825 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Stop 2",
                    observation: "",
                    area: "Zayed Grand Mosque, Abu Dhabi",
                    coOrdinates: { lat: 24.4120, lng: 54.4749 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Stop 3",
                    observation: "",
                    area: "Al Khalidiyah, Abu Dhabi",
                    coOrdinates: { lat: 24.4788, lng: 54.3529 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Destination",
                    observation: "",
                    area: "Al Raha Mall, Abu Dhabi",
                    coOrdinates: { lat: 24.4333, lng: 54.5000 },
                    timeStamp: generateRecentTimestamp(),
                  },
                ],
              },
            },
          },
          {
            tripNo: "2",
            speed: "19 mph",
            fuelConsumed: "18 Gal",
            distanceCovered: "30 Miles",
            driver: "Yousef Al Mazrouei",
            tripStatus: "Completed",
            distance: "130 Miles",
            routeDetails: {
              route: "Route#15",
              occupancy: "28/40",
              videoUrl: "http://busVideoRoute15",
              routeStops: {
                totalStops: "5",
                stopsCovered: "5",
                stoppages: [
                  {
                    name: "Source",
                    observation: "No Delay",
                    area: "Al Maqta, Abu Dhabi",
                    coOrdinates: { lat: 24.3876, lng: 54.5041 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Current Location",
                    observation: "Normal Traffic",
                    area: "Al Rawdah, Abu Dhabi",
                    coOrdinates: { lat: 24.4560, lng: 54.3940 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Stop 1",
                    observation: "Next Stop",
                    area: "Al Wahda Mall, Abu Dhabi",
                    coOrdinates: { lat: 24.4803, lng: 54.3506 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Stop 2",
                    observation: "",
                    area: "Corniche Road, Abu Dhabi",
                    coOrdinates: { lat: 24.4667, lng: 54.3333 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Destination",
                    observation: "",
                    area: "Marina Mall, Abu Dhabi",
                    coOrdinates: { lat: 24.4672, lng: 54.3212 },
                    timeStamp: generateRecentTimestamp(),
                  },
                ],
              },
            },
          },
          {
            tripNo: "3",
            speed: "16 mph",
            fuelConsumed: "16 Gal",
            distanceCovered: "28 Miles",
            driver: "Yousef Al Mazrouei",
            tripStatus: "In Progress",
            distance: "120 Miles",
            routeDetails: {
              route: "Route#18",
              occupancy: "25/40",
              videoUrl: "http://busVideoRoute18",
              routeStops: {
                totalStops: "6",
                stopsCovered: "3",
                stoppages: [
                  {
                    name: "Source",
                    observation: "Trip Started",
                    area: "Al Reem Island, Abu Dhabi",
                    coOrdinates: { lat: 24.4934, lng: 54.4103 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Current Location",
                    observation: "Passenger Onboard",
                    area: "Al Maryah Island, Abu Dhabi",
                    coOrdinates: { lat: 24.5015, lng: 54.3850 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Stop 1",
                    observation: "Next Stop",
                    area: "Al Bateen, Abu Dhabi",
                    coOrdinates: { lat: 24.4500, lng: 54.3500 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Stop 2",
                    observation: "",
                    area: "Al Raha Gardens, Abu Dhabi",
                    coOrdinates: { lat: 24.4500, lng: 54.4833 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Stop 3",
                    observation: "",
                    area: "Khalifa Park, Abu Dhabi",
                    coOrdinates: { lat: 24.4167, lng: 54.5167 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Destination",
                    observation: "",
                    area: "Al Raha Mall, Abu Dhabi",
                    coOrdinates: { lat: 24.4333, lng: 54.5000 },
                    timeStamp: generateRecentTimestamp(),
                  },
                ],
              },
            },
          },
        ],
        pastViolations: [
          {
            violationType: "overspeeding",
            busNo: "33",
            route: "Route#12",
            timeStamp: generateRecentTimestamp(),
          },
          {
            violationType: "harsh braking",
            busNo: "33",
            route: "Route#15",
            timeStamp: generateRecentTimestamp(),
          },
          {
            violationType: "route deviation",
            busNo: "33",
            route: "Route#18",
            timeStamp: generateRecentTimestamp(),
          },
        ],
        source: {
          area: "Al Nahyan, Abu Dhabi",
          coOrdinates: { lat: 24.4667, lng: 54.3667 },
        },
        destination: {
          area: "Al Raha Mall, Abu Dhabi",
          coOrdinates: { lat: 24.4333, lng: 54.5000 },
        },
        currentLocation: {
          area: "Al Mushrif, Abu Dhabi",
          coOrdinates: { lat: 24.4378, lng: 54.3850 },
        },
        nextStop: {
          area: "Khalifa Park, Abu Dhabi",
          coOrdinates: { lat: 24.4181, lng: 54.4825 },
        },
      },
    ],
  },
  completedRoutes: {
    totalCount: "6",
    routes: [
     {
        route: "Route#7",
        busId: "Bus#18",
        noOfBuses: "02",
        fuelConsumed: "22 Gal",
        distanceCovered: "27 Miles",
        stops: "03/06",
        driver: "Hamad Al Neyadi",
        nextMaintanance: "11-05-2025",
        totalPassengers: "23450",
        safetyScore: "91",
        totalTrips: "410",
        licensePlateNo: "AD6235",
        timeStamp: generateRecentTimestamp(),
        trip: [
          {
            tripNo: "1",
            speed: "16 mph",
            fuelConsumed: "17 Gal",
            distanceCovered: "27 Miles",
            driver: "Hamad Al Neyadi",
            tripStatus: "In Progress",
            distance: "110 Miles",
            routeDetails: {
              route: "Route#8",
              occupancy: "22/40",
              videoUrl: "http://busVideoRoute8",
              routeStops: {
                totalStops: "6",
                stopsCovered: "3",
                stoppages: [
                  {
                    name: "Source",
                    observation: "On Time",
                    area: "Al Mushrif, Abu Dhabi",
                    coOrdinates: { lat: 24.4378, lng: 54.3850 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Current Location",
                    observation: "Smooth Ride",
                    area: "Al Nahyan, Abu Dhabi",
                    coOrdinates: { lat: 24.4667, lng: 54.3667 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Stop 1",
                    observation: "Next Stop",
                    area: "Al Khalidiyah, Abu Dhabi",
                    coOrdinates: { lat: 24.4788, lng: 54.3529 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Stop 2",
                    observation: "",
                    area: "Al Bateen, Abu Dhabi",
                    coOrdinates: { lat: 24.4500, lng: 54.3500 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Stop 3",
                    observation: "",
                    area: "Corniche Road, Abu Dhabi",
                    coOrdinates: { lat: 24.4667, lng: 54.3333 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Destination",
                    observation: "",
                    area: "Marina Mall, Abu Dhabi",
                    coOrdinates: { lat: 24.4672, lng: 54.3212 },
                    timeStamp: generateRecentTimestamp(),
                  },
                ],
              },
            },
          },
        ],
        pastViolations: [
          {
            violationType: "overspeeding",
            busNo: "18",
            route: "Route#8",
            timeStamp: generateRecentTimestamp(),
          },
          {
            violationType: "harsh braking",
            busNo: "18",
            route: "Route#8",
            timeStamp: generateRecentTimestamp(),
          },
        ],
        source: {
          area: "Al Mushrif, Abu Dhabi",
          coOrdinates: { lat: 24.4378, lng: 54.3850 },
        },
        destination: {
          area: "Marina Mall, Abu Dhabi",
          coOrdinates: { lat: 24.4672, lng: 54.3212 },
        },
        currentLocation: {
          area: "Al Nahyan, Abu Dhabi",
          coOrdinates: { lat: 24.4667, lng: 54.3667 },
        },
        nextStop: {
          area: "Al Khalidiyah, Abu Dhabi",
          coOrdinates: { lat: 24.4788, lng: 54.3529 },
        },
      },
      {
        route: "Route#8",
        busId: "Bus#20",
        noOfBuses: "01",
        fuelConsumed: "18 Gal",
        distanceCovered: "22 Miles",
        stops: "03/05",
        driver: "Fatima Al Hamadi",
        nextMaintanance: "11-30-2025",
        totalPassengers: "19800",
        safetyScore: "93",
        totalTrips: "375",
        licensePlateNo: "AD7750",
        timeStamp: generateRecentTimestamp(),
        trip: [
          {
            tripNo: "1",
            speed: "15 mph",
            fuelConsumed: "18 Gal",
            distanceCovered: "22 Miles",
            driver: "Fatima Al Hamadi",
            tripStatus: "In Progress",
            distance: "95 Miles",
            routeDetails: {
              route: "Route#10",
              occupancy: "21/40",
              videoUrl: "http://busVideoRoute10",
              routeStops: {
                totalStops: "5",
                stopsCovered: "3",
                stoppages: [
                  {
                    name: "Source",
                    observation: "On Time",
                    area: "Al Mushrif, Abu Dhabi",
                    coOrdinates: { lat: 24.4378, lng: 54.3850 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Current Location",
                    observation: "Steady ride",
                    area: "Al Khalidiyah, Abu Dhabi",
                    coOrdinates: { lat: 24.4788, lng: 54.3529 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Stop 1",
                    observation: "Next Stop",
                    area: "Corniche Road, Abu Dhabi",
                    coOrdinates: { lat: 24.4667, lng: 54.3333 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Stop 2",
                    observation: "",
                    area: "Al Raha Gardens, Abu Dhabi",
                    coOrdinates: { lat: 24.4500, lng: 54.4833 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Destination",
                    observation: "",
                    area: "Al Raha Mall, Abu Dhabi",
                    coOrdinates: { lat: 24.4333, lng: 54.5000 },
                    timeStamp: generateRecentTimestamp(),
                  },
                ],
              },
            },
          },
        ],
        pastViolations: [
          {
            violationType: "overspeeding",
            busNo: "20",
            route: "Route#10",
            timeStamp: generateRecentTimestamp(),
          },
          {
            violationType: "signal jump",
            busNo: "20",
            route: "Route#10",
            timeStamp: generateRecentTimestamp(),
          },
        ],
        source: {
          area: "Al Mushrif, Abu Dhabi",
          coOrdinates: { lat: 24.4378, lng: 54.3850 },
        },
        destination: {
          area: "Al Raha Mall, Abu Dhabi",
          coOrdinates: { lat: 24.4333, lng: 54.5000 },
        },
        currentLocation: {
          area: "Al Khalidiyah, Abu Dhabi",
          coOrdinates: { lat: 24.4788, lng: 54.3529 },
        },
        nextStop: {
          area: "Corniche Road, Abu Dhabi",
          coOrdinates: { lat: 24.4667, lng: 54.3333 },
        },
      },
      {
        route: "Route#9",
        busId: "Bus#3",
        noOfBuses: "02",
        fuelConsumed: "20 Gal",
        distanceCovered: "20 Miles",
        stops: "02/05",
        driver: "Tim John",
        timeStamp: generateRecentTimestamp(),
        source: {
    area: "Khalifa City, Abu Dhabi",
    coOrdinates: {
      lat: 24.421555,
      lng: 54.576599
    }
  },
  destination: {
    area: "Mussafah, Abu Dhabi",
    coOrdinates: {
      lat: 24.4315,
      lng: 54.4247
    }
  },
  currentLocation: {
    area: "Al Mirfa, Abu Dhabi",
    coOrdinates: {
      lat: 24.1327,
      lng: 54.2623
    }
  },
  nextStop: {
    area: "Abu Dhabi International Airport",
    coOrdinates: {
      lat: 24.4320,
      lng: 54.6519
    }
  },
      },
      {
        route: "Route#10",
        busId: "Bus#29",
        noOfBuses: "02",
        fuelConsumed: "24 Gal",
        distanceCovered: "32 Miles",
        stops: "04/06",
        driver: "Noura Al Baloushi",
        nextMaintanance: "12-15-2025",
        totalPassengers: "26800",
        safetyScore: "89",
        totalTrips: "438",
        licensePlateNo: "AD8342",
        timeStamp: generateRecentTimestamp(),
        trip: [
          {
            tripNo: "1",
            speed: "18 mph",
            fuelConsumed: "14 Gal",
            distanceCovered: "28 Miles",
            driver: "Noura Al Baloushi",
            tripStatus: "In Progress",
            distance: "115 Miles",
            routeDetails: {
              route: "Route#14",
              occupancy: "26/40",
              videoUrl: "http://busVideoRoute14",
              routeStops: {
                totalStops: "6",
                stopsCovered: "4",
                stoppages: [
                  {
                    name: "Source",
                    observation: "On Time",
                    area: "Al Maqta, Abu Dhabi",
                    coOrdinates: { lat: 24.3876, lng: 54.5041 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Current Location",
                    observation: "Traffic Moderate",
                    area: "Al Mushrif, Abu Dhabi",
                    coOrdinates: { lat: 24.4378, lng: 54.3850 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Stop 1",
                    observation: "Next Stop",
                    area: "Al Wahda Mall, Abu Dhabi",
                    coOrdinates: { lat: 24.4803, lng: 54.3506 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Stop 2",
                    observation: "",
                    area: "Al Khalidiyah, Abu Dhabi",
                    coOrdinates: { lat: 24.4788, lng: 54.3529 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Stop 3",
                    observation: "",
                    area: "Corniche Road, Abu Dhabi",
                    coOrdinates: { lat: 24.4667, lng: 54.3333 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Destination",
                    observation: "",
                    area: "Marina Mall, Abu Dhabi",
                    coOrdinates: { lat: 24.4672, lng: 54.3212 },
                    timeStamp: generateRecentTimestamp(),
                  },
                ],
              },
            },
          },
          {
            tripNo: "2",
            speed: "20 mph",
            fuelConsumed: "16 Gal",
            distanceCovered: "30 Miles",
            driver: "Noura Al Baloushi",
            tripStatus: "Completed",
            distance: "125 Miles",
            routeDetails: {
              route: "Route#15",
              occupancy: "28/40",
              videoUrl: "http://busVideoRoute15",
              routeStops: {
                totalStops: "7",
                stopsCovered: "7",
                stoppages: [
                  {
                    name: "Source",
                    observation: "No Delay",
                    area: "Al Nahyan, Abu Dhabi",
                    coOrdinates: { lat: 24.4667, lng: 54.3667 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Current Location",
                    observation: "Heavy Traffic",
                    area: "Al Mushrif, Abu Dhabi",
                    coOrdinates: { lat: 24.4378, lng: 54.3850 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Stop 1",
                    observation: "Next Stop",
                    area: "Al Khalidiyah, Abu Dhabi",
                    coOrdinates: { lat: 24.4788, lng: 54.3529 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Stop 2",
                    observation: "",
                    area: "Al Raha Gardens, Abu Dhabi",
                    coOrdinates: { lat: 24.4500, lng: 54.4833 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Stop 3",
                    observation: "",
                    area: "Saadiyat Island, Abu Dhabi",
                    coOrdinates: { lat: 24.5325, lng: 54.4244 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Stop 4",
                    observation: "",
                    area: "Khalifa Park, Abu Dhabi",
                    coOrdinates: { lat: 24.4181, lng: 54.4825 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Destination",
                    observation: "",
                    area: "Al Raha Mall, Abu Dhabi",
                    coOrdinates: { lat: 24.4333, lng: 54.5000 },
                    timeStamp: generateRecentTimestamp(),
                  },
                ],
              },
            },
          },
        ],
        pastViolations: [
          {
            violationType: "overspeeding",
            busNo: "29",
            route: "Route#14",
            timeStamp: generateRecentTimestamp(),
          },
          {
            violationType: "harsh braking",
            busNo: "29",
            route: "Route#15",
            timeStamp: generateRecentTimestamp(),
          },
        ],
        source: {
          area: "Al Maqta, Abu Dhabi",
          coOrdinates: { lat: 24.3876, lng: 54.5041 },
        },
        destination: {
          area: "Marina Mall, Abu Dhabi",
          coOrdinates: { lat: 24.4672, lng: 54.3212 },
        },
        currentLocation: {
          area: "Al Mushrif, Abu Dhabi",
          coOrdinates: { lat: 24.4378, lng: 54.3850 },
        },
        nextStop: {
          area: "Al Khalidiyah, Abu Dhabi",
          coOrdinates: { lat: 24.4788, lng: 54.3529 },
        },
      },
      {
        route: "Route#11",
        busId: "Bus#35",
        noOfBuses: "03",
        fuelConsumed: "30 Gal",
        distanceCovered: "36 Miles",
        stops: "05/07",
        driver: "Salim Al Hammadi",
        nextMaintanance: "12-22-2025",
        totalPassengers: "29500",
        safetyScore: "90",
        totalTrips: "475",
        licensePlateNo: "AD8390",
        timeStamp: generateRecentTimestamp(),
        trip: [
          {
            tripNo: "1",
            speed: "18 mph",
            fuelConsumed: "15 Gal",
            distanceCovered: "28 Miles",
            driver: "Salim Al Hammadi",
            tripStatus: "In Progress",
            distance: "120 Miles",
            routeDetails: {
              route: "Route#17",
              occupancy: "25/40",
              videoUrl: "http://busVideoRoute17",
              routeStops: {
                totalStops: "7",
                stopsCovered: "4",
                stoppages: [
                  {
                    name: "Source",
                    observation: "On Time",
                    area: "Al Nahyan, Abu Dhabi",
                    coOrdinates: { lat: 24.4667, lng: 54.3667 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Current Location",
                    observation: "Smooth Ride",
                    area: "Al Mushrif, Abu Dhabi",
                    coOrdinates: { lat: 24.4378, lng: 54.3850 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Stop 1",
                    observation: "Next Stop",
                    area: "Khalifa Park, Abu Dhabi",
                    coOrdinates: { lat: 24.4181, lng: 54.4825 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Stop 2",
                    observation: "",
                    area: "Zayed Grand Mosque, Abu Dhabi",
                    coOrdinates: { lat: 24.4120, lng: 54.4749 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Destination",
                    observation: "",
                    area: "Al Raha Mall, Abu Dhabi",
                    coOrdinates: { lat: 24.4333, lng: 54.5000 },
                    timeStamp: generateRecentTimestamp(),
                  },
                ],
              },
            },
          },
          {
            tripNo: "2",
            speed: "20 mph",
            fuelConsumed: "17 Gal",
            distanceCovered: "33 Miles",
            driver: "Salim Al Hammadi",
            tripStatus: "Completed",
            distance: "130 Miles",
            routeDetails: {
              route: "Route#18",
              occupancy: "28/40",
              videoUrl: "http://busVideoRoute18",
              routeStops: {
                totalStops: "6",
                stopsCovered: "6",
                stoppages: [
                  {
                    name: "Source",
                    observation: "No Delay",
                    area: "Al Maqta, Abu Dhabi",
                    coOrdinates: { lat: 24.3876, lng: 54.5041 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Current Location",
                    observation: "Normal Traffic",
                    area: "Al Rawdah, Abu Dhabi",
                    coOrdinates: { lat: 24.4560, lng: 54.3940 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Stop 1",
                    observation: "Next Stop",
                    area: "Al Wahda Mall, Abu Dhabi",
                    coOrdinates: { lat: 24.4803, lng: 54.3506 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Stop 2",
                    observation: "",
                    area: "Corniche Road, Abu Dhabi",
                    coOrdinates: { lat: 24.4667, lng: 54.3333 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Destination",
                    observation: "",
                    area: "Marina Mall, Abu Dhabi",
                    coOrdinates: { lat: 24.4672, lng: 54.3212 },
                    timeStamp: generateRecentTimestamp(),
                  },
                ],
              },
            },
          },
          {
            tripNo: "3",
            speed: "17 mph",
            fuelConsumed: "16 Gal",
            distanceCovered: "29 Miles",
            driver: "Salim Al Hammadi",
            tripStatus: "In Progress",
            distance: "125 Miles",
            routeDetails: {
              route: "Route#19",
              occupancy: "26/40",
              videoUrl: "http://busVideoRoute19",
              routeStops: {
                totalStops: "5",
                stopsCovered: "3",
                stoppages: [
                  {
                    name: "Source",
                    observation: "Trip Started",
                    area: "Al Reem Island, Abu Dhabi",
                    coOrdinates: { lat: 24.4934, lng: 54.4103 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Current Location",
                    observation: "Passenger Boarding",
                    area: "Al Maryah Island, Abu Dhabi",
                    coOrdinates: { lat: 24.5015, lng: 54.3850 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Stop 1",
                    observation: "Next Stop",
                    area: "Al Bateen, Abu Dhabi",
                    coOrdinates: { lat: 24.4500, lng: 54.3500 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Stop 2",
                    observation: "",
                    area: "Al Raha Gardens, Abu Dhabi",
                    coOrdinates: { lat: 24.4500, lng: 54.4833 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Destination",
                    observation: "",
                    area: "Khalifa Park, Abu Dhabi",
                    coOrdinates: { lat: 24.4167, lng: 54.5167 },
                    timeStamp: generateRecentTimestamp(),
                  },
                ],
              },
            },
          },
        ],
        pastViolations: [
          {
            violationType: "overspeeding",
            busNo: "35",
            route: "Route#17",
            timeStamp: generateRecentTimestamp(),
          },
          {
            violationType: "harsh braking",
            busNo: "35",
            route: "Route#18",
            timeStamp: generateRecentTimestamp(),
          },
        ],
        source: {
          area: "Al Nahyan, Abu Dhabi",
          coOrdinates: { lat: 24.4667, lng: 54.3667 },
        },
        destination: {
          area: "Al Raha Mall, Abu Dhabi",
          coOrdinates: { lat: 24.4333, lng: 54.5000 },
        },
        currentLocation: {
          area: "Al Mushrif, Abu Dhabi",
          coOrdinates: { lat: 24.4378, lng: 54.3850 },
        },
        nextStop: {
          area: "Khalifa Park, Abu Dhabi",
          coOrdinates: { lat: 24.4181, lng: 54.4825 },
        },
      },
      {
        route: "Route#12",
        busId: "Bus#42",
        noOfBuses: "03",
        fuelConsumed: "33 Gal",
        distanceCovered: "37 Miles",
        stops: "05/07",
        driver: "Mariam Al Mazrouei",
        nextMaintanance: "12-28-2025",
        totalPassengers: "28800",
        safetyScore: "91",
        totalTrips: "480",
        licensePlateNo: "AD8405",
        timeStamp: generateRecentTimestamp(),
        trip: [
          {
            tripNo: "1",
            speed: "19 mph",
            fuelConsumed: "16 Gal",
            distanceCovered: "30 Miles",
            driver: "Mariam Al Mazrouei",
            tripStatus: "In Progress",
            distance: "120 Miles",
            routeDetails: {
              route: "Route#20",
              occupancy: "27/40",
              videoUrl: "http://busVideoRoute20",
              routeStops: {
                totalStops: "7",
                stopsCovered: "5",
                stoppages: [
                  {
                    name: "Source",
                    observation: "On Time",
                    area: "Al Rawdah, Abu Dhabi",
                    coOrdinates: { lat: 24.4560, lng: 54.3940 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Current Location",
                    observation: "Steady Ride",
                    area: "Al Khalidiyah, Abu Dhabi",
                    coOrdinates: { lat: 24.4788, lng: 54.3529 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Stop 1",
                    observation: "Next Stop",
                    area: "Al Mushrif, Abu Dhabi",
                    coOrdinates: { lat: 24.4378, lng: 54.3850 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Stop 2",
                    observation: "",
                    area: "Al Nahyan, Abu Dhabi",
                    coOrdinates: { lat: 24.4667, lng: 54.3667 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Stop 3",
                    observation: "",
                    area: "Corniche Road, Abu Dhabi",
                    coOrdinates: { lat: 24.4667, lng: 54.3333 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Stop 4",
                    observation: "",
                    area: "Marina Mall, Abu Dhabi",
                    coOrdinates: { lat: 24.4672, lng: 54.3212 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Destination",
                    observation: "",
                    area: "Yas Island, Abu Dhabi",
                    coOrdinates: { lat: 24.4885, lng: 54.6050 },
                    timeStamp: generateRecentTimestamp(),
                  },
                ],
              },
            },
          },
          {
            tripNo: "2",
            speed: "21 mph",
            fuelConsumed: "17 Gal",
            distanceCovered: "32 Miles",
            driver: "Mariam Al Mazrouei",
            tripStatus: "Completed",
            distance: "135 Miles",
            routeDetails: {
              route: "Route#22",
              occupancy: "29/40",
              videoUrl: "http://busVideoRoute22",
              routeStops: {
                totalStops: "6",
                stopsCovered: "6",
                stoppages: [
                  {
                    name: "Source",
                    observation: "Early Start",
                    area: "Al Maqta, Abu Dhabi",
                    coOrdinates: { lat: 24.3876, lng: 54.5041 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Current Location",
                    observation: "Normal Traffic",
                    area: "Al Rawdah, Abu Dhabi",
                    coOrdinates: { lat: 24.4560, lng: 54.3940 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Stop 1",
                    observation: "Next Stop",
                    area: "Al Wahda Mall, Abu Dhabi",
                    coOrdinates: { lat: 24.4803, lng: 54.3506 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Stop 2",
                    observation: "",
                    area: "Al Khalidiyah, Abu Dhabi",
                    coOrdinates: { lat: 24.4788, lng: 54.3529 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Destination",
                    observation: "",
                    area: "Corniche Road, Abu Dhabi",
                    coOrdinates: { lat: 24.4667, lng: 54.3333 },
                    timeStamp: generateRecentTimestamp(),
                  },
                ],
              },
            },
          },
          {
            tripNo: "3",
            speed: "15 mph",
            fuelConsumed: "15 Gal",
            distanceCovered: "28 Miles",
            driver: "Mariam Al Mazrouei",
            tripStatus: "In Progress",
            distance: "120 Miles",
            routeDetails: {
              route: "Route#25",
              occupancy: "26/40",
              videoUrl: "http://busVideoRoute25",
              routeStops: {
                totalStops: "5",
                stopsCovered: "3",
                stoppages: [
                  {
                    name: "Source",
                    observation: "Trip Started",
                    area: "Al Reem Island, Abu Dhabi",
                    coOrdinates: { lat: 24.4934, lng: 54.4103 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Current Location",
                    observation: "Passenger Boarding",
                    area: "Al Maryah Island, Abu Dhabi",
                    coOrdinates: { lat: 24.5015, lng: 54.3850 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Stop 1",
                    observation: "Next Stop",
                    area: "Al Bateen, Abu Dhabi",
                    coOrdinates: { lat: 24.4500, lng: 54.3500 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Stop 2",
                    observation: "",
                    area: "Al Raha Gardens, Abu Dhabi",
                    coOrdinates: { lat: 24.4500, lng: 54.4833 },
                    timeStamp: generateRecentTimestamp(),
                  },
                  {
                    name: "Destination",
                    observation: "",
                    area: "Khalifa Park, Abu Dhabi",
                    coOrdinates: { lat: 24.4167, lng: 54.5167 },
                    timeStamp: generateRecentTimestamp(),
                  },
                ],
              },
            },
          },
        ],
        pastViolations: [
          {
            violationType: "overspeeding",
            busNo: "35",
            route: "Route#17",
            timeStamp: generateRecentTimestamp(),
          },
          {
            violationType: "harsh braking",
            busNo: "35",
            route: "Route#18",
            timeStamp: generateRecentTimestamp(),
          },
        ],
        source: {
          area: "Al Rawdah, Abu Dhabi",
          coOrdinates: { lat: 24.4560, lng: 54.3940 },
        },
        destination: {
          area: "Yas Island, Abu Dhabi",
          coOrdinates: { lat: 24.4885, lng: 54.6050 },
        },
        currentLocation: {
          area: "Al Khalidiyah, Abu Dhabi",
          coOrdinates: { lat: 24.4788, lng: 54.3529 },
        },
        nextStop: {
          area: "Al Mushrif, Abu Dhabi",
          coOrdinates: { lat: 24.4378, lng: 54.3850 },
        },
      },
    ],
  },
};
export default routes;
